import { memo, PropsWithChildren } from 'react';
import { Tooltip as RACTooltip, TooltipProps as RACTooltipProps } from 'react-aria-components';

import { ComponentContextProps, merge, renderWithContext, useComponent } from '@/components';

export type TooltipProps = PropsWithChildren<RACTooltipProps> & Partial<ComponentContextProps>;

const ITooltip = ({ placement = 'bottom', variant, className, children, offset = 4, ...rest }: TooltipProps) => {
  const context = useComponent({ variant });

  /* prettier-ignore */
  const styles  = [
    'border-1',
    'flex',
    'gap-1',
    'group/tooltip',
    'px-1.75',
    'py-0.75',
    'rounded-sm',
    'shadow-lg',
  ];

  /* prettier-ignore */
  const plainStyles = [
    'bg-white',
    'border-gray-200',
  ];

  /* prettier-ignore */
  const primaryStyles = [
    'bg-gray-900',
  ];

  /* prettier-ignore */
  const secondaryStyles = [
    'bg-white',
    'border-gray-200',
  ];

  /* prettier-ignore */
  const tertiaryStyles = [
    'bg-gray-900',
  ];

  /* prettier-ignore */
  const successStyles = [
    'bg-success-50',
    'border-success-100',
  ];

  /* prettier-ignore */
  const warningStyles = [
    'bg-warning-50',
    'border-warning-100',
  ];

  /* prettier-ignore */
  const errorStyles = [
    'bg-error-50',
    'border-error-100',
  ];

  return (
    <RACTooltip
      className={merge(
        styles,
        context.variant === 'default' && plainStyles,
        context.variant === 'plain' && plainStyles,
        context.variant === 'primary' && primaryStyles,
        context.variant === 'secondary' && secondaryStyles,
        context.variant === 'tertiary' && tertiaryStyles,
        context.variant === 'success' && successStyles,
        context.variant === 'warning' && warningStyles,
        context.variant === 'error' && errorStyles,
        className
      )}
      placement={placement}
      offset={offset}
      {...rest}
    >
      {renderWithContext(children, context)}
    </RACTooltip>
  );
};

export const Tooltip = memo(ITooltip) as typeof ITooltip;
